import { render, staticRenderFns } from "./UploadImagePopup.vue?vue&type=template&id=97e1017a&scoped=true&"
import script from "./UploadImagePopup.vue?vue&type=script&lang=js&"
export * from "./UploadImagePopup.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagePopup.vue?vue&type=style&index=0&id=97e1017a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e1017a",
  null
  
)

export default component.exports